import React from 'react';

const PlusIcon = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.0002 1.20001L6.0002 10.8M10.8002 6.00001L1.2002 6.00001" stroke="current" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>

    );
};

export default PlusIcon;